import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EmployeeTransport, EmployeeWorkTime, ManualShiftChanges, OperationalTask, WorkTask } from "../../types/ganttChart";

export type SelectedTask = {
  task: WorkTask | OperationalTask;
  employeeName?: string;
};

type SelectedEmployee = {
  employeeShiftId: number;
  employeeName: string;
  employeeRef: string
  employeeWorkTime: EmployeeWorkTime;
  transportationType: EmployeeTransport[]
  manualShiftChanges?: ManualShiftChanges
};

type DrawerType = "Task" | "Employee"

type DrawerContentToDisplay =
  { drawerContent: SelectedTask, type: "Task" }
  | { drawerContent: SelectedEmployee, type: "Employee" }

export interface DrawerSlice {
  isDrawerOpen: boolean;
  drawerType?: DrawerType;
  selectedTask?: SelectedTask;
  selectedEmployee?: SelectedEmployee;
}

const initialState: DrawerSlice = {
  isDrawerOpen: false,
};

const drawerSlice = createSlice({
  name: "drawer",
  initialState,
  reducers: {
    openDrawer(state, action: PayloadAction<DrawerContentToDisplay>) {
      state.isDrawerOpen = true;
      state.drawerType = action.payload.type
      if (action.payload.type === "Task") {
        state.selectedTask = action.payload.drawerContent
      } else {
        state.selectedEmployee = action.payload.drawerContent
      }
    },
    closeDrawer(state) {
      state.isDrawerOpen = false;
      delete state.selectedTask;
      delete state.selectedEmployee;
      delete state.drawerType
    },
  },
});

export const { openDrawer, closeDrawer } = drawerSlice.actions;

export default drawerSlice.reducer;
